import map from 'lodash/map';

export default (obj) => {
  return map(obj, (label, value) => ({label, value}));
};
